export default __webpack_public_path__ + "static/media/icon-delete-red.bd8337ba.svg";